import { Tooltip } from "@gravity-ui/uikit";

interface NameCellProps {
  name: string;
}

export const NameCell = ({ name }: NameCellProps) => {
  return (
    <Tooltip content={name} placement={"top"} openDelay={100}>
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {name}
      </div>
    </Tooltip>
  );
};
